module.exports = __webpack_public_path__ + "static/media/HampAkt.e8f09cef.jpg";